import React from 'react';
import './App.css';
import LikeButton from './components/like-button';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          This is misterleif.com home
        </p>
        <LikeButton />
      </header>
    </div>
  );
}

export default App;
